import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import PrimaryDialogButton from 'components/PrimaryDialogButton';
import SecondaryDialogButton from 'components/SecondaryDialogButton';
import classNames from 'classnames';
import styles from './styles';
import m from 'messages';

class DurationPicker extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
            hours: props.hours || 0,
            minutes: props.minutes || 0,
            dialogHours: props.hours || 0,
            dialogMinutes: props.minutes || 0
        };
    }

    handleHourChange = (event) => {
        this.setState({ dialogHours: Number(event.currentTarget.value) });
    };

    handleMinutesChange = (event) => {
        this.setState({ dialogMinutes: Number(event.currentTarget.value) });
    };

    onAccept = () => {
        this.props.onChange(this.state.dialogHours, this.state.dialogMinutes);
        this.setState({
            dialogOpen: false,
            hours: this.state.dialogHours,
            minutes: this.state.dialogMinutes
        });
    };

    onCancel = () => {
        this.setState({ dialogOpen: false });
    }

    render() {
        const { dialogOpen, hours, dialogHours, minutes, dialogMinutes } = this.state;
        const { classes, promptTitle } = this.props;

        return (
            <React.Fragment>
                <Dialog open={dialogOpen} onClose={this.onCancel}>
                    <DialogTitle>{promptTitle}</DialogTitle>
                    <DialogContent>
                        <form className={classes.container}>
                            <FormControl className={classes.formControl}>
                                <InputLabel htmlFor="hours">
                                    {m.general.hours}
                                </InputLabel>
                                <Select native value={dialogHours} onChange={this.handleHourChange} input={<Input id="hours" type="number" />}>
                                    <option value="" />
                                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(n =>
                                        <option value={n} key={n}>{n}</option>
                                    )}
                                </Select>
                            </FormControl>

                            <FormControl className={classes.formControl}>
                                <InputLabel htmlFor="minutes">
                                    {m.general.minutes}
                                </InputLabel>
                                <Select native value={dialogMinutes} onChange={this.handleMinutesChange} input={<Input id="minutes" type="number" />}>
                                    <option value="" />
                                    {[0, 15, 30, 45].map(n =>
                                        <option value={n} key={n}>{n}</option>
                                    )}
                                </Select>
                            </FormControl>
                        </form>
                    </DialogContent>
                    <DialogActions className={classes.actions}>
                        <SecondaryDialogButton onClick={this.onCancel}>{m.general.cancel}</SecondaryDialogButton>
                        <PrimaryDialogButton onClick={this.onAccept}>{m.general.ok}</PrimaryDialogButton>
                    </DialogActions>
                </Dialog>

                <div className={classes.container}>
                    <div className={classNames(classes.formControl, classes.formLabel)}>
                        {hours.toString()}h {minutes.toString()}m
                    </div>
                    <div className={classes.formControl}>
                        <Button variant="outlined" color="primary" onClick={() => this.setState({ dialogOpen: true })}>
                            {m.general.update}
                        </Button>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

DurationPicker.propTypes = {
    promptTitle: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    hours: PropTypes.number,
    minutes: PropTypes.number,
};

export default withStyles(styles)(DurationPicker);
